// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class ParseInformation extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  destinationFieldName?: string;
  displayOrder!: number;
  fileType!: number;
  justification?: string;
  length!: number;
  startPosition!: number;
  templateFieldName?: string;
  valueType?: string;
}

